import React, { Component } from 'react';
import '../../styles/css/users/Settings.css';

class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {

        return (
            <div className="headerCardRoot">
                Settings
            </div>
        )
    }
}

export default Settings;


// WEBPACK FOOTER //
// ./src/pages/Users/Settings.js